module.exports = __webpack_public_path__ + "static/img/pm.1e97e8d7.svg";